import { WEBSITE_ID } from "../projectConfig";

export const DB_BOOKING_WEBSITES_REF = `booking-websites/`;
export const DB_WEBSITE_REF = `booking-websites/${WEBSITE_ID}/`
export const SERVICES_DB_REF = `${DB_WEBSITE_REF}services/`;
export const HOMEPAGE_DB_REF = `${DB_WEBSITE_REF}config/homepage/`;
export const BUSINESS_INFO_DB_REF = `${DB_WEBSITE_REF}config/businessInfo/`;
export const GALLERY_DB_REF = `${DB_WEBSITE_REF}config/homepage/gallery/`;
export const EMPLOYEES_DB_REF = `${DB_WEBSITE_REF}employees/`;

export const createBookingWebsiteDbRef = (siteId:string, path?:string) =>{
    if(path){
        return `booking-websites/${siteId}/${path}`
    }
    return `booking-websites/${siteId}/`
}
